import BasePopupHandler, {
    PopupMainButtonLocations,
    MAIN_BUTTON_ANCHORS,
} from './BasePopupHandler';
import GameObject from '../../../GameObject/GameObject';
import UIItem, { ITextData} from '../../../Prototype/UI/UIItem';
import Game from '../../../Game';
import { GameActions } from '../../../State/Game/GameActions';
import BaseUISystem from '../BaseUISystem';
import UITextComponent from '../../../Component/UI/Text';
import { IUIButtonData } from '../../../Prototype/UI/BaseElements/UIButton';
import { LevelStatus } from '../../../State/Level/LevelStatus';
import { TextAlignment } from '../../../Prototype/UI/TextAlignment';
import { PopupID } from '../../../State/UI/PopupID';

export default class QuitMenuHandler extends BasePopupHandler {
    constructor(uiSystem: BaseUISystem) {
        super(PopupID.QUIT_MENU, uiSystem);
    }

    public onShow(params?: any) {
        super.onShow(params);
        const titleText: string = Game.locale
            .getText('Level')
            .replace('[x]', params);
        this.background
            .find(this.levelTitleParams.name)
            .getComponent(UITextComponent).text = titleText;
    }

    createPopup(params?: any) {
        this.underlayParams.cacheKey = 'level_complete_underlay';
        this.submitBtnParams.background.layout.anchors =
            MAIN_BUTTON_ANCHORS[PopupMainButtonLocations.LEFT];
        // this.submitBtnParams.text.textLocalizationKey = 'PlayOn';
        this.submitBtnParams.text.textLocalizationKey = 'KeepPlaying';

        super.createPopup({
            buttons: [
                this.quitBtnParams,
                this.submitBtnParams,
                this.closeBtnParams,
            ],
            underlay: this.underlayParams,
        });
        //this.createQuitBtn();

        // this.title = Game.locale.getText('QuitLevel');
        this.title = Game.locale.getText('EndLevelCaps');

        this.createMainInfo();
    }
    private createMainInfo(): void {
        const text: GameObject<PIXI.Container> = UIItem.createText(
            this.textParams
        );
        const title: GameObject<PIXI.Container> = UIItem.createText(
            this.levelTitleParams
        );

        this.background.addChild(text);
        this.background.addChild(title);
    }

    protected onQuit(): void {
        GameActions.endLevel({
            status: LevelStatus.EXITING,
            firstComplete: false,
        });
    }
    protected quitBtnParams: IUIButtonData = {
        name: 'quit_btn_group',
        text: {
            name: 'quit_btn_text',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 6, 0, 6],
                scale: [1, 1],
            },
            // textLocalizationKey: 'GiveUp',
            textLocalizationKey: 'EndLevel',
            style: Game.style.getStyle('popup.red_btn'),
            align: TextAlignment.CENTER,
            bounds: [220, 130],
        },
        button: {
            name: 'quit_btn',
            layout: {
                anchors: [0.5, 0.5, 0.5, 0.5],
                pivot: [0.5, 0.5],
                offsets: [0, 55, 0, 55],
                scale: [1, 1],
            },
            cacheKey: 'button_medium_red',
        },
        background: {
            name: 'quit_btn_bg',
            layout: {
                anchors: MAIN_BUTTON_ANCHORS[PopupMainButtonLocations.RIGHT],
                pivot: [0.5, 1],
                offsets: [0, -10, 0, -10],
                scale: [1, 1],
            },
            cacheKey: 'blank',
        },
        onClick: this.onQuit.bind(this),
    };
    protected textParams: ITextData = {
        name: 'quit_popup_text',
        // textLocalizationKey: 'QuitLevel?',
        textLocalizationKey: 'EndLevel?',
        layout: {
            anchors: [0.5, 0.55, 0.5, 0.55],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        style: {
            font: 'FrancoisOne',
            fill: '#8b3130',
            fontSize: '32px',
        },
    };
    protected levelTitleParams: ITextData = {
        name: 'quit_popup_title',
        textLocalizationKey: 'Level',
        layout: {
            anchors: [0.5, 0.45, 0.5, 0.45],
            pivot: [0.5, 0.5],
            offsets: [0, 0, 0, 0],
            scale: [1, 1],
        },
        style: {
            font: 'FrancoisOne',
            fill: '#bb3c2f',
            fontSize: '46px',
        },
    };
}
